import { render, staticRenderFns } from "./RouteDetail.vue?vue&type=template&id=329c5f9b&scoped=true&"
import script from "./RouteDetail.vue?vue&type=script&lang=js&"
export * from "./RouteDetail.vue?vue&type=script&lang=js&"
import style0 from "./RouteDetail.vue?vue&type=style&index=0&id=329c5f9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329c5f9b",
  null
  
)

export default component.exports